import React from "react";
import profile from "../../../images/profile/Untitled-6.jpg";
import file from "../../../images/Resume/Mern_Stack_Resume_Of_KUTUB UDDIN.pdf";
import video from "../../../images/video/video.mp4";
import "./Banner.css";
import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();
const Banner = () => {
  return (
    <div className="relative bg-black bg-opacity-70 overflow-hidden">
      <div className="video-container relative">
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "350px",
            position: "absolute",
            top: "0",
            backgroundPosition: "cover",
            backgroundRepeat: "no-repeat",
            left: "0",
            zIndex: "-10000",
            objectFit: "cover",
          }}
        >
          <source type="video/mp4" src={video}></source>
        </video>
        <div className="overlay">
  <div className="flex flex-col justify-center items-start h-full px-[8%] space-y-3">
  <h1 className="text-xl text-white font-medium">Welcome to JMK</h1>
  
  <h1 className="text-4xl md:text-5xl font-extrabold text-white">
    I'm <span className="text-[#00A9FF]">Kutub Uddin</span>
  </h1>
  
  <p className="text-lg md:text-xl text-gray-300 font-medium">
    I build modern and interactive web applications
  </p>

  <div className="mt-3 flex items-center gap-2 text-2xl md:text-4xl lg:text-5xl font-extrabold text-slate-200">
    As a{" "}
    <span className="text-[#00A9FF]">
      <Typewriter
        options={{
          strings: [
            "Full Stack Developer",
            "Front-End Developer",
            "React.js Developer",
            "Next.js Developer",
            "Laravel Developer",
          ],
          autoStart: true,
          loop: true,
        }}
      />
    </span>
  </div>
</div>

</div>

      </div>
      <div className="imgBox  bg-inherit">
        <div
          className="img py-8"
          data-aos="fade-right"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
        >
          <img src={profile} alt="" />
        </div>
        <div
          className=" text-left sm:mt-16 sm:ml-6 mb-6 sm:mb-0"
          data-aos="fade-up"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-anchor-placement="top-center"
        >
          <h1 className="">About Me</h1>
          <h1 className="text-4xl font-extrabold  mb-3 text-[#00A9FF]">I'm Kutub Uddin</h1>
          <p className="text-justify">
            {" "}
            Outside of just being pretty awesome, Currently I am studying in
            Bachelor's Of Business Administration in Premier University,
            Chittagong,Bangladesh. Programming is my fashion and it's a dream to
            become a Senior Developer in Bangladesh. Within the 1.5 years I
            already learnt so many technologies with full attention and
            dedication. I already completed Web development Course{" "}
          </p>

          <button className="resume mt-8 sm:mt-6 sm:mb-5">
            <Link to={file} target="_blank" download>
              Download Resume
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
